import React from 'react';
import './InstagramCTA.css';
import { FiInstagram } from 'react-icons/fi';

const InstagramCTA = () => {
    return (
        <div className="instagram-cta-container container">
            <div className="instagram-cta-content">
                <FiInstagram size={48} className="cta-icon" />
                <div className="cta-text">
                    <h2>Follow us on Instagram</h2>
                    <p>Get the latest updates, behind-the-scenes, and exclusive offers!</p>
                </div>
                <a 
                    // --- IMPORTANT: Change this link to your client's Instagram URL ---
                    href="https://www.instagram.com/madurai_special_official" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="cta-button"
                >
                    @madurai_special
                </a>
            </div>
        </div>
    );
};

export default InstagramCTA;
